import { Match, Switch, createEffect, onCleanup } from "solid-js";

import { LoopRegion } from "#components/loop-region";
import { Waveform } from "#components/waveform";

export function Sample(props: SampleProps) {
	let playheadRef: HTMLDivElement | undefined = undefined;
	let unsubscribe: (() => void) | undefined = undefined;

	createEffect(() => {
		unsubscribe?.();
		unsubscribe = props.subscribeToPositionRatio?.((ratio) => {
			if (playheadRef) {
				playheadRef.style.transform = `translateX(${ratio * 100}%)`;
			}
		});
	});

	onCleanup(() => {
		unsubscribe?.();
	});

	return (
		<div class="relative size-full">
			<div class="absolute inset-0 z-1">
				<Waveform buffer={props.audioBuffer} />
			</div>
			<Switch>
				<Match when={Boolean(props.audioBuffer)}>
					<>
						<div class="pointer-events-none absolute inset-0 z-1 overflow-hidden">
							<div
								class="pointer-events-none absolute inset-0 z-2 before:absolute before:inset-y-0 before:left-0 before:w-px before:bg-emphasis-600"
								ref={(el) => (playheadRef = el)}
							/>
						</div>
						<div class="absolute inset-0 z-3">
							<LoopRegion
								loopStart={props.loopStart ?? 0}
								loopEnd={props.loopEnd ?? 1}
								onLoopStartDrag={props.onLoopStartDrag}
								onLoopEndDrag={props.onLoopEndDrag}
								onLoopRegionDrag={props.onLoopRegionDrag}
							/>
						</div>
					</>
				</Match>
				<Match when={!props.audioBuffer}>
					<button
						class="absolute inset-0 z-3 flex flex-col items-center justify-center gap-2 bg-surface-0 p-12"
						tabIndex={0}
						onClick={() => props.selectAudioFile?.()}
					>
						<Switch fallback={"Click to load audio file or drag it here"}>
							<Match when={props.fromSaved}>
								<>
									<span class="text-center">
										Unfortunately audio data is not saved with a project
									</span>
									<span class="text-center">
										Click here (or drag and drop) to load files again
									</span>
								</>
							</Match>
						</Switch>
					</button>
				</Match>
			</Switch>
		</div>
	);
}

export interface SampleProps {
	audioBuffer: AudioBuffer | undefined;
	fromSaved?: boolean | undefined;
	loopStart?: number | undefined;
	loopEnd?: number | undefined;
	onLoopStartDrag?: ((movement: number) => unknown) | undefined;
	onLoopEndDrag?: ((movement: number) => unknown) | undefined;
	onLoopRegionDrag?: ((movement: number) => unknown) | undefined;
	selectAudioFile?: (() => unknown) | undefined;
	subscribeToPositionRatio?:
		| ((handler: (ratio: number) => void) => () => void)
		| undefined;
}
